$(function () {
    var url = location.href;

    var parameterIndex = url.indexOf('?');
    if (parameterIndex > 0) {
        var parameterString = url.substring(parameterIndex);
        var url = url.substring(0, parameterIndex);
        var parameterArray = parameterString.split(/[?&]/g);

        parameterString = "";
        var i;
        for (i = 0; i < parameterArray.length; i++) {
            var parameter = parameterArray[i];
            if(parameter.length > 0 && !parameter.startsWith("d=")){
                if(parameterString === ""){
                    parameterString += "?";
                }else{
                    parameterString += "&";
                }
                parameterString += parameter;
            }
        }
        url += parameterString;
        var stateObj = {
            url: url,
            originalURL: location.href,
            title: $(document).find("title").text()
        };
        window.history.replaceState(stateObj, stateObj.title, stateObj.url);
    }
});
